import React, { Component } from 'react';
import LetterOfMedicalNecessityDownload from './LetterOfMedicalNecessityDownload';
import LetterOfMedicalNecessityForm from './LetterOfMedicalNecessityForm';

class LetterOfMedicalNecessityDisplay extends Component {   
    render() {
        const { submitted, pdfUrl, toTop } = this.props;
        let displayView;

        if (submitted) {
            displayView = <LetterOfMedicalNecessityDownload pdfUrl={pdfUrl} />;
        } else {
            displayView = <LetterOfMedicalNecessityForm />;
        }
        return (
            displayView
        )
    }
}
  
export default LetterOfMedicalNecessityDisplay;